module.exports = __webpack_public_path__ + "static/onion-bread-5db285e2d0dd56d57e58248a108f2c4c.jpg";